// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"Badge__badgeWrapper____81OH"};